import React from "react";
import { useAuth } from './auth-context/auth.context';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import SweetAlert from "react-bootstrap-sweetalert";

// const pattern = /^\/region\/:[a-zA-Z0-9]+$/;
const pattern = /^\/region\/[^/]+$/;
export const ProtectedRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const parts = location.pathname.split("/");

  if (!user || !user.token || user.token === "") {
    // Save the current location (pathname + search) in localStorage to redirect later
    localStorage.setItem("redirectAfterLogin", location.pathname + location.search);
    
    // Show an alert asking to login and then redirect to the login page
    return (
      <SweetAlert
        title="You must be signed in!"
        onCancel={() => navigate("/login")}
        onConfirm={() => navigate("/login")}
        confirmBtnCssClass={"px-5"}
      />
    );
  }

  return <Outlet />;  // If authenticated, show the protected content
};
